// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bp-0";
export var headerCellHover = "_bp-1";
export var readCellContainer = "_bp-2";
export var readCellSlot = "_bp-3";
export var rowHoverCheckbox = "_bp-4";
export var rowUnreadIndicator = "_bp-5";
export var searchHighlight = "_bp-8";
export var supportTicketRow = "_bp-6";
export var unreadIndicator = "_bp-7";